import { useState } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import RoomModal from './Components/RoomModal'
import Login from './modules/auth/login'
import History from './modules/history'
import YouTubePlayer from './modules/youTube-player'
import { ProtectedRoute } from './utils/ProtectedRoute'

export default function App() {
  const [roomId, setRoomId] = useState(
    () => localStorage.getItem('roomId') || ''
  )
  const router = createBrowserRouter([
    {
      path: '/',
      element: roomId ? (
        <YouTubePlayer roomId={roomId} />
      ) : (
        <RoomModal setRoomId={setRoomId} />
      ),
      loader: ProtectedRoute,
    },
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/activity-log',
      element: <History />,
      loader: () => ProtectedRoute({ requiredRole: 'admin' }),
    },
  ])

  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}
